import React, { Component } from "react";

class BookingFinalizationComponent extends Component {

    render() { 
        return (  
            <section className="section-xl bg-periglacial-blue one-screen-page-content text-center">
            <div className="shell">
              <h2 id="zakazivanjeNaslov" dangerouslySetInnerHTML={{__html: this.props.bookingStatus.statusZakazivanjaNaslov}}></h2>
              <div className="p text-width-small">
                <p className="big" dangerouslySetInnerHTML={{__html: this.props.bookingStatus.statusZakazivanjaTekst}}></p>
              </div><a className="btn btn-sm btn-style-1 btn-white-pickled-bluewood" href="/">Nazad na početnu stranicu</a>
            </div>
          </section>          
      );
    }
}
 
export default BookingFinalizationComponent;